/**
 * OmniCut Core Package
 * Shared types, utilities, and business logic
 * @packageDocumentation
 */

// Export all types
export * from './types';

// Export utilities
export * from './utils';
export * from './utils/format';

// Package version
export const VERSION = '1.0.0-alpha';
